//引入api这里是所有请求的管理
import {req_user, req_ltry, req_shop, req_hd, req_score} from './api'

//home页面请求在首页可以import引入gethome方法获取数据后面可以传递地址参数请求方式
export function q_hd(url, baseurl, params, is_loading = false) {
  return req_hd({url:url, baseURL: baseurl, params: params, headers: { showLoading: is_loading}})
}
export function set_anchor(go_id, token){
  return this.q_hd('SendPageLog', 'https://open.09game.com/pagelog', {go_id: go_id, token: token})
}
// 获取cookie信息
export function getCookieJs() {
  return req_user({url:'getcookiejs', params: {}})
}
// 微信切换账号
export function setLoginByWx(token, user_id, openId) {
  return req_user({url:'SetLoginByWx', params: {token: token, user_id: user_id, openId: openId }})
}
// 微信openid查看是否有绑定
export function getwxBindByOpenid(openId,  is_loading = false) {
  return req_user({url:'GetUserByWxOpenid', params: {openId: openId }, method: 'post', headers: { showLoading: is_loading}})
}
// 微信openid免密登录
export function userOpenidLogin(openId, m_key,  is_loading = false) {
  return req_user({url:'UserByWxLogin', params: {openId: openId, m_key: m_key }, method: 'post', headers: { showLoading: is_loading}})
}
// 微信手机号密码登录
export function userHttpLogin(user_number, password) {
  return req_user({url:'UserNewHttpLogin', params: {user_number: user_number, password: password }, method: 'post'})
}
// 微信手机号验证码登录
export function userMobileLogin(m_key, user_number, key, openid) {
  return req_user({url:'UserLoginMobile', params: {m_key: m_key, user_number: user_number, key: key, openid: openid}, method: 'post'})
}
// 微信注册绑定
export function userRegisterByWx(m_key, phone, key, openId, user_name, real_name, id_card, check_id) {
  return req_user({url:'UserRegisterByWx', params: {
        m_key: m_key, LoginMobile: phone, phone: phone, key: key, openId: openId,
        user_name: user_name, real_name: real_name, id_card: id_card, check_id: check_id},
   method: 'post'})
}
// 获取用户基础信息
export function getUserInfo(token, is_loading = false) {
  return req_user({url:'GetUserInfoV1', params: {token: token}, headers: { showLoading: is_loading}})
}
// 获取用户账号下绑定的所有账号信息
export function getAllUser(token) {
  return req_user({url:'GetAllUserV1', params: {token: token}})
}
// 获取用户基础信息
export function getUserPub(user_id) {
    return req_user({url:'GetUserPub', params: {user_id: user_id}})
}
// 获取用户基础信息（根据姓名）
export function getUserPubByName(user_name, token) {
  return req_user({url:'GetUserIdV1', params: {user_name: user_name, token: token}})
}
// 获取用户是否绑定微信
export function getUserWechat(token) {
  return req_user({url:'GetUserWechatStatus', params: {token: token}})
}
// 获取用户充值等级
export function getUserAchievementDetails(token) {
  return req_user({url:'GetUserAchievementDetails', params: {token: token}})
}
// 获取用户勋章
export function getUserMedal(user_id) {
  return req_user({url:'GetUserMedal', params: {user_id: user_id, status: 0}})
}
// 获取用户成就值
export function getUserAchievement(user_id) {
  return req_user({url:'GetUserAchievement', params: {user_id: user_id}})
}
// 绑定微信
export function bindUserWechat(m_key, openid, account, password) {
  return req_user({url:'NewUserBindWechat', params: {m_key: m_key, openId: openid, account: account, password: password}})
}
// 解绑微信
export function unlockUserWechat(token, password) {
  return req_user({url:'UserWechatUnlockV1', params: {token: token, password: password}})
}
// 解绑微信new
export function unlockWechat(token, openid) {
  return req_user({url:'UserWXUnlock', params: {token: token, openid: openid}})
}
// 获取图形码
export function getCaptchImg() {
  return req_user({url:'Code', params: {}})
}
// 校验图形码
export function verificationCode(code, check_id) {
  return req_user({url:'VerificationCode', params: {code: code, check_id: check_id}})
}
// 发送手机短信
export function sedNote(phone) {
  return req_user({url:'SedNote', params: {phoneNumber: phone, templateCode: 'SMS_27330147', type: 1}})
}

export function sendCode(phone, check_id , token) {
  return req_user({url:'NewSedNoteV1', params: { phoneNumber: phone, check_id: check_id , token:token}})
}

export function SecureSedNote(phone, check_id) {
  return req_user({url:'SecureSedNote', params: { phoneNumber: phone, check_id: check_id }})
}

// 校验手机短信验证码
export function verificationNote(phone, code, check_id) {
  return req_user({url:'VerificationNote', params: {phoneNumber: phone, code: code, check_id: check_id}})
}
// 发送邮箱
export function sedEmail(email) {
  return req_user({url:'SedEmail', params: {email: email}})
}
// 校验邮箱验证码
export function verificationEmail(email, code, check_id) {
  return req_user({url:'VerificationEmail', params: {email: email, code: code, check_id: check_id}})
}
// 查询我的道具
export function q_my_item(item_id, token) {
    return req_shop({type:'q_my_item', params: {item_id: item_id, token: token}})
}
// 查询活动任务
export function q_cfg_task(app_id) {
    return req_shop({type:'q_cfg_task', params: {app_id: app_id}})
}
// 查询活动礼包
export function q_cfg_packet(app_id) {
    return req_shop({type:'q_cfg_packet', params: {app_id: app_id}})
}
// 查询我的任务
export function q_my_task(app_id, token) {
    return req_shop({type:'q_my_task', params: {app_id: app_id, token: token}})
}
// 查询我的礼包
export function q_my_packet(app_id, token) {
    return req_shop({type:'q_my_packet', params: {app_id: app_id, token: token}})
}
// 查询已经使用的礼包
export function q_my_packet_use(app_id, token) {
  return req_shop({type:'q_my_packet_use', params: {app_id: app_id, token: token}})
}
// 使用礼包
export function use_packet(packet_id, token, opt = 0) {
  return req_shop({type:'use_packet', params: {packet_id: packet_id, token: token, opt: opt}})
}
// 使用道具（兑换）
export function use_item(dest_id, token, amount) {
  return req_shop({type:'use_item', params: {dest_id: dest_id, token: token, amount: amount}})
}
// 查询道具兑换信息
export function q_cfg_item(item_id) {
  return req_shop({type:'q_cfg_item', params: {item_id: item_id}})
}
// 购买任务
export function buy_task(price, task_id, token) {
  return req_shop({type:'buy_task', params: {price: price, task_id: task_id, token: token}})
}
// 购买礼包
export function buy_goods(price, goods_id, token) {
  return req_shop({type:'buy_goods', params: {price: price, goods_id: goods_id, token: token}})
}
// 查询礼包价格
export function q_cfg_goods(goods_id, token) {
  return req_shop({type:'q_cfg_goods', params: {goods_id: goods_id, token: token}})
}
// 查询我的酒币酒豆余额
export function q_my_money(token) {
  return req_shop({type:'q_my_money', params: {token: token}})
}
// 查询我的充值记录
export function q_my_charge(days, token, start, count = 500) {
  return req_shop({type:'q_my_charge', params: {Days: days, Token: token, Start: start, Count: count}})
}
// 查询我的消费记录
export function q_my_sub(days, token, start, count = 500) {
  return req_shop({type:'q_my_sub', params: {Days: days, Token: token, Start: start, Count: count}})
}
// 查询我的酒豆记录
export function q_my_detail(days, token, start, count = 500) {
  return req_shop({type:'q_my_detail', params: {Days: days, Token: token, Start: start, Count: count}})
}
// 查询抽奖池
export function q_cfg_list(app_id) {
  return req_ltry({type:'q_cfg_list', params: {app_id: app_id}})
}
// 查询我的抽奖记录
export function q_my_lottery(app_id, token) {
  return req_ltry({type:'q_my_lottery', params: {app_id: app_id, token: token}})
}
// 查询活动中奖信息
export function q_notice(app_id) {
  return req_ltry({type:'q_notice', params: {app_id: app_id}})
}
// 抽奖
export function lottery(app_id, times, key, token) {
  return req_ltry({type: times == 1 ? 'single' : 'multi', params: {app_id: app_id, count: times,  key: key, token: token}})
}
// 查询我的抽奖次数
export function q_my_lottery_count(app_id, token) {
  return req_ltry({type:'q_my_lottery_count', params: {app_id: app_id, token: token}})
}

// 查询用户历史战绩信息（赛季，自由，总计）
export function querySeasonSummary(user_id, game_type_id) {
  return req_score({url:'Ordinary/SeasonSummaryV1', params: {UserID: user_id, GameTypeID: game_type_id}})
}
// 查询用户mvp称号之类的信息
export function queryGameTitle(user_id, game_type_id) {
  return req_score({url:'MOBA/GameTitle', params: {userId: user_id, gameTypeId: game_type_id}})
}
// 查询用户最近游戏信息
export function queryBasicDataList(user_id, game_type_id, page_index, page_size , token, current_season = 0, game_source = -1, time = -1) {
  return req_score({url:'MOBA/BasicDataListV3', params: {
      UserID: user_id,
      GameTypeID: game_type_id,
      PageIndex: page_index,
      PageSize: page_size,
      token: token,
      CurrentSeason: current_season,
      GameSource: game_source,
      Time: time
  }})
}
// 查询用户历史赛季游戏信息
export function queryHistorySeasonList(user_id, game_type_id, season, dota_map = 687) {
  return req_score({url:'MOBA/HistorySeasonList', params: {userId: user_id, gameTypeId: game_type_id, Season: season, DotaMap: dota_map}})
}
// 查询用户雷达图数据信息
export function queryRadarData(user_id, game_type_id) {
  return req_score({url:'MOBA/GameDataStatistics', params: {UserID: user_id, GameTypeID: game_type_id}})
}
// 查询用户赛季排名
export function queryUserRanking(user_id, game_type_id) {
  return req_score({url:'MOBA/UserRankingV1', params: {UserID: user_id, GameTypeID: game_type_id}})
}

// 查询我的任务
export function q_my_task2(app_id, token, day) {
  return req_shop({type:'q_my_task', params: {app_id: app_id, token: token, day: day}})
}



// WEBPACK FOOTER //
// ./src/utils/req.js